import { Component, effect, inject, signal } from '@angular/core';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { InputModule } from '@beautyapp/form';
import { georgianIdValidator, georgianMobileNumberValidator, UserService, UserVerifyService, fromCalendarDate } from '@beautyapp/core';
import { format } from 'date-fns';
import { DatepickerComponent } from '../../../../../form/src/lib/datepicker/datepicker.component';

@Component({
  selector: 'beautyapp-user-verify',
  templateUrl: './user-verify.component.html',
  styleUrls: ['./user-verify.component.scss'],
  imports: [
    NzModalFooterDirective,
    NzButtonComponent,
    NzFormDirective,
    ReactiveFormsModule,
    InputModule,
    DatepickerComponent
]
})
export class UserVerifyComponent {
  modalRef = inject(NzModalRef);
  userVerifyService = inject(UserVerifyService);
  userService = inject(UserService);

  userId = inject(NZ_MODAL_DATA).userId;
  user = signal<any>(null);

  smsSent = signal(false);

  form = new FormGroup({
    email: new FormControl(null, [Validators.email]),
    mobilePhone: new FormControl(null, [Validators.required, georgianMobileNumberValidator()]),
    firstname: new FormControl(null, Validators.required),
    lastname: new FormControl(null, Validators.required),
    identityNumber: new FormControl(null, [Validators.required, georgianIdValidator()]),
    userId: new FormControl(null, Validators.required),
    // Typed: the control holds a picker Date, and `new FormControl(null)`
    // infers `null` — which is why patching a real date failed to compile.
    birthDate: new FormControl<Date | null>(null, Validators.required)
  });

  verifyForm = new FormGroup({
    code: new FormControl(null, Validators.required),
    userId: new FormControl(null, Validators.required)
  });

  constructor() {
    this.loadUser();

    effect(() => {
      if (this.user()) {
        this.form.patchValue({
          email: this.user().email,
          mobilePhone: this.user().mobilePhone,
          firstname: this.user().firstname,
          lastname: this.user().lastname,
          identityNumber: this.user().identityNumber,
          userId: this.user().id,
          birthDate: fromCalendarDate(this.user().birthDate)
        });

        this.verifyForm.patchValue({
          userId: this.user().id
        });
      }
    });
  }

  loadUser() {
    this.userService.getById(this.userId).subscribe((user) => {
      this.user.set(user);
    });
  }

  startVerify() {
    console.log('User verified', this.user());

    this.form.markAllAsTouched();

    console.log('Form', this.form);

    if (this.form.invalid) return;

    const {
      email,
      mobilePhone,
      firstname,
      lastname,
      identityNumber,
      userId,
      birthDate
    } = this.form.value as any;

    this.userVerifyService.startVerifyUser({
      email,
      mobilePhone,
      firstname,
      lastname,
      identityNumber,
      userId,
      birthDate: format(birthDate, 'yyyy-MM-dd')
    }).subscribe((res: any) => {
      console.log('User verified', res);
      this.smsSent.set(true);
    });

  }

  verifySms() {
    this.verifyForm.markAllAsTouched();

    if (this.verifyForm.invalid) return;

    const {
      code,
      userId
    } = this.verifyForm.value as any;

    console.log('Verifying sms', code, userId);

    this.userVerifyService.verifyUser({
      code,
      userId
    }).subscribe((res: any) => {
      console.log('User verified', res);
      this.modalRef.triggerOk();
    });
  }

  resend() {
    this.userVerifyService.resendVerifyUser({
      userId: this.user().id
    }).subscribe((res: any) => {
      console.log('User verified', res);
      this.smsSent.set(true);
    });
  }
}
